export default {
    data: function () {
        return {
            service: '',
            reloadBus: null,
            defaultFormModel: {},
            showForm: false,
            formModel: {},
            formTitle: '',
            formErrors: [],
        }
    },
    methods: {
        create: function () {
            this.formModel = {};
            this.formModel = Object.assign({}, this.formModel, this.defaultFormModel);
            this.formTitle = this.$t('create');
            this.formErrors = [];
            this.showForm = true;
        },
        update: function (id) {
            let loader = this.$loading.show();
            this.$service.get(this.service + '/' + id).then(response => {
                this.formModel = {};
                this.formTitle = this.$t('update');
                this.formErrors = [];
                this.showForm = true;
                this.formModel = response.data;
                this.formModel.id = id;
            }).finally(() => {
                loader.hide();
            });
        },
        save: function (evt, fn, customUrl) {
            if (evt) {
                evt.preventDefault();
            }
            let loader = this.$loading.show();
            let method = 'post';
            let url = this.service;
            if (this.formModel.id) {
                method = 'put';
                url += '/' + this.formModel.id;
            }
            if (customUrl) {
                url = customUrl;
            }
            this.$service({url: url, method: method, data: this.formModel}).then(response => {
                this.showForm = false;
                if (this.load) {
                    this.load();
                }
                if (this.reloadBus) {
                    this.$bus.$emit(this.reloadBus);
                }
                if (fn) {
                    fn();
                }
                if (response.data) {
                    this.$swal({
                        title: this.$t('success'),
                        text: this.$t(this.formModel.id ? 'updated' : 'created'),
                        icon: 'success'
                    });
                } else {
                    this.$swal({
                        title: this.$t('error'),
                        text: this.$t(this.formModel.id ? 'updateFailed' : 'createFailed'),
                        icon: 'error'
                    });
                }
            }).catch(error => {
                if (error.response.data.message) {
                    this.$swal({
                        text: error.response.data.message,
                        icon: 'error'
                    });
                    this.showForm = false;
                } else {
                    this.formErrors = error.response.data;
                }
            }).finally(() => {
                loader.hide();
            });
        },
        del: function (id) {
            this.$swal({
                title: this.$t('deleteConfirm'),
                text: this.$t('deleteAlert'),
                icon: "warning",
                showCancelButton: true
            }).then((result) => {
                if (result.value) {
                    let loader = this.$loading.show();
                    this.$service.delete(this.service + '/' + id).then(response => {
                        if (response.data) {
                            if (this.load) {
                                this.load();
                            }
                            if (this.reloadBus) {
                                this.$bus.$emit(this.reloadBus);
                            }
                            this.$swal({
                                title: this.$t('success'),
                                text: this.$t('deleted'),
                                icon: 'success'
                            });
                        } else {
                            this.$swal({
                                title: this.$t('error'),
                                text: this.$t('deleteFailed'),
                                icon: 'error'
                            });
                        }
                    }).catch(error => {
                        if (error.response.data.message) {
                            this.$swal({
                                text: error.response.data.message,
                                icon: 'error'
                            });
                        }
                    }).finally(() => {
                        loader.hide();
                    });
                }
            });
        },
    },
    mounted: function () {
        this.formModel = {};
        Object.assign(this.formModel, this.defaultFormModel);
    }
};